export * from './GTMScript';
